import { render, staticRenderFns } from "./CadItem.vue?vue&type=template&id=2b1a4834&scoped=true&"
import script from "./CadItem.vue?vue&type=script&lang=js&"
export * from "./CadItem.vue?vue&type=script&lang=js&"
import style0 from "./CadItem.vue?vue&type=style&index=0&id=2b1a4834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a4834",
  null
  
)

export default component.exports